import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './document.css'
import { withTranslation } from 'react-i18next'

class Document extends Component {

    static propTypes = {
        sourceLoaded: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    }

    componentDidMount()
    {
        this.props.sourceLoaded()
    }

    render() {
        const { location, t } = this.props

        return (
            <a href={location.original} target="_blank" rel="noopener noreferrer" className="document-wrapper" title={t('visualizer:media.document.download')}><i className="fa fa-download" /></a>
        )
    }
}

export default withTranslation()(Document)
